import { useQuery } from "@tanstack/react-query";
import { getHomeBanners } from "../apis/banners";

export function useHomeBanners() {
  return useQuery({
    queryKey: ['homeBanners'],
    queryFn: getHomeBanners,
    cacheTime: 1_000 * 60 * 30,
    retry: true
  });
}
